import React from 'react';
type EsteveWordmarkProps = {
  className?: string;
  /** Light version for dark backgrounds. */
  inverse?: boolean;
};

/** Typographic stand-in for the ESTEVE logo (wordmark + "Improving lives together") — replace with the official ESTEVE SVG asset. */
export function EsteveWordmark({
  className = '',
  inverse = false
}: EsteveWordmarkProps) {
  const color = inverse ? 'text-white' : 'text-[var(--fg)]';
  return <span className={`inline-flex flex-col leading-none ${className}`} aria-label="ESTEVE — Improving lives together" data-id="element-47" data-mp="11wq5s9ob31gd">
      <span className={`font-['Saira'] text-[22px] font-semibold tracking-[0.04em] ${color}`} data-id="element-48" data-mp="15wqjfs3kz8md">ESTEVE</span>
      <span className={`mt-0.5 text-[8.5px] font-medium tracking-[0.04em] ${inverse ? 'text-white/75' : 'text-[var(--brand)]'}`} data-id="element-49" data-mp="rx919vksitlz">Improving lives together</span>
    </span>;
}